import { css } from '@emotion/css';

export const headerStyles = css`
  padding-inline-start: 0.8rem !important;
`;

export const taskStatusRowStyles = css`
  padding-inline-start: 0.2rem !important;
`;

export const dueDateRowStyles = css`
  padding-inline-start: 0.4rem !important;
`;

export const assigneeRowStyles = css`
  padding-inline-start: 0.2rem !important;
`;

export const optionsStyles = css`
  padding-inline-end: 1.6rem !important;
`;
